import { render } from "./LandingPage.vue?vue&type=template&id=ec7a01da&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"

import "./LandingPage.vue?vue&type=style&index=0&id=ec7a01da&scoped=true&lang=scss"

import exportComponent from "/Users/jackwaghorn/Documents/Projects/VibeLab/XP/Xp mircosite/xp-v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec7a01da"]])

export default __exports__